module.exports = __webpack_public_path__ + "img/流体力学4_1_1.98ed2cb0.jpg";